var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "files" },
    [
      _vm._l(_vm.agendaFiles, function(file, index) {
        return _c("FileAttachment", { key: index, attrs: { file: file } })
      }),
      _vm._v(" "),
      _vm._l(_vm.blankFiles, function(file, index) {
        return _c("FileAttachmentSkeleton", { key: "skeleton-file-" + index })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }